import { render, staticRenderFns } from "./BlockContextMenu.vue?vue&type=template&id=73a1d4e7&scoped=true&"
import script from "./BlockContextMenu.vue?vue&type=script&lang=js&"
export * from "./BlockContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./BlockContextMenu.vue?vue&type=style&index=0&id=73a1d4e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a1d4e7",
  null
  
)

export default component.exports